/** @jsx jsx */
import {jsx, css} from '@emotion/react'
import Button from '../../button'

const Cta = ({onCtaClick}) => {
    return (
        <section
            css={css`
                background: #fafbfd;
                padding: 2rem;
                margin: 2rem 0;
                text-align: center;
                border-radius: 10px;
            `}
        >
            <p
                css={css`
                    margin: 1rem 0 !important;
                    font-size: 1.5rem !important;
                    font-size: min(max(1.25rem, 3vw), 1.5rem) !important;
                    font-family: 'Proxima Nova SemiBold', sans-serif;
                    line-height: 1.25;
                `}
            >
                Take back control of your data and start searching in private for free!
            </p>
            <Button text="Search In Private" onClick={onCtaClick} />
        </section>
    )
}

export default Cta
